import type { FrameAuthState } from './frame-client';

export interface RuntimeSource {
  token(): string;
  refresh(): Promise<string>;
  signal: AbortSignal;
  revision: number;
  permissions: readonly string[];
  authState(state: Exclude<FrameAuthState, 'checking' | 'authenticated'>): void;
}

let source: RuntimeSource | null = null;
export const runtimeSession = (): RuntimeSource | null => source;
export function setRuntimeSession(value: RuntimeSource | null): void { source = value; }
